export const Istate =  [
  "Andhra Pradesh",
  "Andaman and Nicobar Islands",
   "Arunachal Pradesh", 
   "Assam", 
   "Bihar", 
   "Chandigarh", 
   "Chhattisgarh", 
   "Dadar and Nagar Haveli",
   "Daman and Diu",
   "Delhi", 
   "Lakshadweep", 
   "Puducherry", 
   "Goa", 
   "Gujarat", 
   "Haryana", 
   "Himachal Pradesh",
   "Jammu and Kashmir",
   "Jharkhand", 
   "Karnataka", 
   "Kerala", 
   "Madhya Pradesh",
   "Maharashtra", 
   "Manipur", 
   "Meghalaya", 
   "Mizoram", 
   "Nagaland", 
   "Odisha", 
   "Punjab", 
   "Rajasthan", 
   "Sikkim", 
   "Tamil Nadu", 
   "Telangana",
   "Tripura",
   "Uttar Pradesh",
   "Uttarakhand",
   "West Bengal"
   
  ];

  export const Icountry =  [
  "INDIA"
  
  ]
  export const IDays =  [
    "Sunday",
    "Monday",
    "Tuesday",
    
    ]




